class MulticolumnCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    this.carousel = this.setupCarousel()
    this.setupListeners()
  }

  setupListeners () {
    this.listeners.add(window, 'resize', () => {
      this.manageCarousel()
    })

    this.manageCarousel()
  }

  manageCarousel () {
    const isMobile = window.matchMedia('(max-width: 768px)').matches

    if (isMobile && this.classList.contains('keen-slider')) {
      if (!this.carousel) {
        this.carousel = this.setupCarousel()
      }
    } else if (this.carousel) {
      this.carousel.destroy()
      this.carousel = null
    }
  }

  setupCarousel () {
    return new window.KeenSlider(
      this,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 1.25,
          spacing: 2,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 3,
            },
          },
        },
      },
      [
        window.BAO.carousel.useInitialised(),
        window.BAO.carousel.useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('multicolumn-carousel')) {
  customElements.define('multicolumn-carousel', MulticolumnCarousel)
}